'use client';

import { cn } from '@/lib/tailwind';
import { useConsent } from './ConsentProvider';

type Props = {
    className?: string;
    children?: string;
};

export function CookieSettingsLink({ className, children = 'Cookie-Einstellungen' }: Props) {
    const { openSettings } = useConsent();

    return (
        <button
            type="button"
            onClick={openSettings}
            className={cn(
                'underline underline-offset-4 transition-colors hover:text-primary-400 cursor-pointer',
                className,
            )}
        >
            {children}
        </button>
    );
}
